import { faTimesCircle, IconDefinition } from '@fortawesome/sharp-solid-svg-icons';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import './WhiteBackgroundModal.css';
import { Button } from '../../components/button/Button';
import useKeyboardAction from '../../hooks/useKeyboardAction';

type WhiteBackgroundModalProps = {
  hasCloseIcon: boolean;
  id: string;
  title: {
    text: string;
    showTitle: boolean;
  };
  dialogTitle: string;
  size?: 'mini' | 'small' | 'medium' | 'large';
  submitButton?: {
    text: string;
    onClick: () => void;
    icon?: IconDefinition;
  };
  cancelButton?: {
    text: string;
    onClick: () => void;
    icon?: IconDefinition;
  };
  handleClose: () => void;
  children: React.ReactNode;
};

export function WhiteBackgroundModal({
  hasCloseIcon,
  id,
  title,
  dialogTitle,
  size = 'medium',
  submitButton,
  cancelButton,
  handleClose,
  children,
}: WhiteBackgroundModalProps) {
  const { t } = useTranslation();

  useKeyboardAction(() => {
    handleClose();
  }, 'Escape');

  return (
    <FocusLock returnFocus>
      <div className="popup-overlay" role="dialog" aria-modal="true">
        <div
          id={id}
          className={`white-background-modal ${size}`}
          aria-labelledby={`modal-title-${id}`}
        >
          {hasCloseIcon && (
            <Button
              ariaLabel={t('modal.close')}
              className="close-icon"
              icon={{ faIconDefinition: faTimesCircle }}
              onClick={handleClose}
              variant="icon-only"
            />
          )}
          <div className={`white-background-modal-header ${title.showTitle ? 'with-border' : ''}`}>
            <h2
              id={`modal-title-${id}`}
              className={`modal-title ${title.showTitle ? 'show' : 'hide'}`}
            >
              {title.text}
            </h2>
          </div>
          <div className="white-background-modal-body">{children}</div>
          {submitButton || cancelButton ? (
            <div
              className={`white-background-modal-footer ${submitButton && cancelButton ? 'double' : 'single'}`}
            >
              {cancelButton && (
                <Button
                  className="modal-button"
                  onClick={cancelButton.onClick}
                  color="dark"
                  variant="secondary"
                >
                  {cancelButton.text.toUpperCase()}
                </Button>
              )}
              {submitButton && (
                <Button className="modal-button" onClick={submitButton.onClick}>
                  {submitButton.text.toUpperCase()}
                </Button>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </FocusLock>
  );
}
